import { ff } from '@atlassian/jira-feature-flagging';
import { useResource } from '@atlassian/jira-router';
import { gicOptInStatusResources } from '@atlassian/jira-router-resources-global-issue-create-switch';

export const isModernGlobalIssueCreateEnabled = () =>
	ff('project.config.pce.modern.global-issue-create', false);

export const useIsModernGlobalIssueCreatePreferred = () =>
	useResource(gicOptInStatusResources).data?.gicOptInStatus?.isEnabled ?? false;
